import {Button, Container, Grid, Paper} from '@material-ui/core';
import 'AgencyAdministration/components/EmulationNoAccess.sass';
import React from 'react';
import {useDispatch} from 'react-redux';
import {Link} from 'react-router-dom';
import {stopImpersonation} from 'Users/ducks/agentAdministration';

type EmulationNoAccessProps = {
  originalUserName: string;
};

const EmulationNoAccess = ({originalUserName}: EmulationNoAccessProps) => {
  const dispatch = useDispatch();

  return (
    <Container maxWidth="lg" className="emulation-no-access">
      <Paper className="emulation-no-access__paper">
        <Grid container justify="center" direction="column">
          <Grid item>
            <h1 className="emulation-no-access__title">Access Denied</h1>
            <p>The page you are returning to is not accessible to the user you are emulating.</p>
          </Grid>
          <Grid item>
            <Grid container justify="flex-end">
              <Link to="/">
                <Button variant="contained" className="emulation-no-access__stop-impersonation-button">
                  Return to Home
                </Button>
              </Link>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  dispatch(stopImpersonation(originalUserName));
                }}
              >
                Un-Emulate
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default EmulationNoAccess;
